import Backbone from 'backbone'
import _ from 'lodash'
import $ from 'jquery'
import template from './db-connection-step1.hbs'
import FormView from 'scoreboard/components/form-view'
import DatabaseConfiguration from './database-configuration'
import formHelper from 'scoreboard/components/form-helper'
import selects from 'scoreboard/components/selects'
import Database from './database'

var DbConnectionStep1 = Backbone.View.extend({

	className: 'connection-wizard',

	tagName: 'form',

	events: {
		'change [name=product]': 'onChangeProduct'
	},

	/**
	 * The first step of the wizard used to modify database connections
	 * (#13318 and #13932)
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Connection} options.model the connection being modified
	 *
	 * @param {String} options.title the title to use for the dialog
	 *
	 * @param {String} [options.validationUrl='api/admin/databases/validate']
	 * 	the url used to validate the connection
	 */
	initialize(options = {}) {
		this.options = options
		this.formView = new FormView({
			el: this.el,
			allowCleanSubmission: true,
			submit: this.submit.bind(this)
		})
	},

	render() {
		this.$el.empty().append(template({ title: this.options.title }))
		// #44888 display the db product select only if a product was not
		// previously selected
		if (_.isNil(this.model.get('product'))) {
			this.$('select[name=product]').removeClass('is-not-displayed')
		}
		formHelper.writeToDom(this.model, this.el)
		selects(this.$('select'))

		this.renderDatabaseConfiguration()

		// record the old value for the product
		this.onChangeProduct()

		this.options.wizard.render({
			formView: this.formView,
			stateSaver: this.saveState.bind(this)
		})
		this.formView.start()
		return this
	},

	renderDatabaseConfiguration: function() {
		this.databaseConfiguration = new DatabaseConfiguration({
			model: this.model,
			product: this.$('[name=product]').val()
		})
		this.$('.database-configuration-container').empty().append(this.databaseConfiguration.el)
		this.databaseConfiguration.render()
	},

	/**
	 * Callback executed when the database product dropdown changes (e.g.
	 * MySQL -> SQL Server).  Records the previous selection of the product, and
	 * if the port was just set to the default for the database, changes the
	 * port to be the default port corresponding to the new database product
	 * selection.
	 */
	onChangeProduct() {
		let product = this.$('[name=product]').val()
		if (this.oldProduct) {
			let oldProductDefaultPort = Database.getDefaultPort(this.oldProduct)
			if (oldProductDefaultPort == this.$('[name=port]').val()) {
				let product = this.$('[name=product]').val()
				this.$('[name=port]').val(Database.getDefaultPort(product))
			}
		}

		this.oldProduct = product
		this.renderDatabaseConfiguration()
	},

	saveState() {
		_.extend(this.model.attributes, formHelper.readFromDom(this.el))
	},

	submit() {
		let database = _.defaults(formHelper.readFromDom(this.el),
			this.options.model.attributes)
		return $.post({
			url: _.get(this.options, 'validationUrl', 'api/admin/databases/validate'),
			data: JSON.stringify(database),
			success: () => this.options.wizard.next(),
			error: this.formView.error.bind(this.formView)
		})
	},

	remove() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.formView, this.databaseConfiguration], 'remove')
	}

})

export default DbConnectionStep1

DbConnectionStep1.__filename__ = 'admin/connections/db-connection-step1.js'
